/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Wpm_LabelInputs */



/**
* | output |
* | --- |
* | "WPM" |
*
* @param {Event_Warning_Wpm_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_wpm_label = /** @type {((inputs?: Event_Warning_Wpm_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Wpm_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("MPM")
	if (locale === "de") return /** @type {LocalizedString} */ ("WPM")
	if (locale === "it") return /** @type {LocalizedString} */ ("WPM")
	if (locale === "ru") return /** @type {LocalizedString} */ ("слов в минуту")
	if (locale === "es") return /** @type {LocalizedString} */ ("palabras por minuto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每分钟字数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1分あたり")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डब्ल्यूपीएम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Palavras por minuto")
	return /** @type {LocalizedString} */ ("WPM")
});